import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { 
	setCameraMode as setCameraModeReducer,
} from './reducer';

export const cameraSlice = createSlice({
  name: 'camera',
  initialState: initialState,
  reducers: {
    setCameraMode: setCameraModeReducer,
  },
});

export const { setCameraMode } = cameraSlice.actions;
/*
export const getInputData = (object, input) => {
  return (state) => state.checkin2[object].form[input];
};
*/

export const getCameraModeSelector = (state) => state.camera.cameraMode;

export default cameraSlice.reducer;